import { Injectable } from '@angular/core';
import { map, throwIfEmpty } from 'rxjs/operators';
import { DateTime } from 'luxon';
import { Subject, BehaviorSubject, Observable } from 'rxjs';

import { Fetch } from '@app/models/fetch';
import { Notification } from '@app/models/notifications/notifications.model';
import { Page } from '../page';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    baseUrl = '/notifications';
    // observable for unread notifications
    private _unreadNotifications: Subject<Array<Notification>> = new BehaviorSubject<Array<Notification>>(null);
    public readonly unreadNotifications: Observable<Array<Notification>> = this._unreadNotifications.asObservable(); // eslint-disable-line

    constructor(private fetch: Fetch) {}

    get(id: number) {
        return this.fetch.getOne(this.baseUrl, id).model(Notification);
    }

    getPage(page: Page, options?: any) {
        return this.fetch.getPage<Notification>(this.baseUrl, page, options).models(Notification);
    }

    getAll(options?: any) {
        return this.fetch.getAll<Notification>(this.baseUrl, options).models(Notification);
    }

    getAllDevice(id: string) {
        return this.fetch
            .getAll<Notification>(this.baseUrl, { device_id: id })
            .req.pipe(map((res) => res.data));
    }

    delete(id: number) {
        return this.fetch.delete<Notification>(this.baseUrl, id);
    }

    setRead(id: number, read: boolean) {
        return this.fetch.patch<Notification>(this.baseUrl, id, { read });
    }

    getUnreadNotifications(id) {
        return this.getAll({ location_id: id, read: false })
            .pipe()
            .subscribe((res) => {
                this._unreadNotifications.next(res);
            });
    }
}
